/* eslint-disable react/prop-types */
import { AlertCircle, ExternalLink, Store, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

const NotRegisteredModal = ({ isOpen, onClose, phoneNumber }) => {
  const handleRegisterClick = () => {
    window.open('https://register.biglocal.in', '_blank');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-sm mx-auto p-0 overflow-hidden rounded-xl animate-in zoom-in duration-300">
        <div className="bg-gradient-to-r from-[#F77C06] to-orange-600 p-4 text-white relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 p-1 rounded-full hover:bg-white/20 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="flex items-center space-x-2">
            <div className="p-2 bg-white/20 rounded-full">
              <Store className="h-5 w-5" />
            </div>
            <div>
              <h2 className="text-lg font-bold">Not Registered</h2>
            </div>
          </div>
        </div>

        <div className="p-4 space-y-4">
          {/* Alert message */}
          <div className="flex items-start space-x-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm">
              <p className="font-medium text-red-800">Account Not Found</p>
              <p className="text-red-700 text-xs">
                {phoneNumber ? `${phoneNumber} not registered` : 'Phone number not registered'}
              </p>
            </div>
          </div>

          <div className="text-center space-y-2">
            <p className="text-gray-800 text-sm font-semibold">
              Join Biglocal and grow your business online!
            </p>
          </div>

          <div className="space-y-2 pt-1">
            <Button
              onClick={handleRegisterClick}
              className="w-full h-11 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg flex items-center justify-center space-x-2 transition-colors"
            >
              <span>Register Now</span>
              <ExternalLink className="h-4 w-4" />
            </Button>

            <Button
              onClick={onClose}
              variant="outline"
              className="w-full h-9 rounded-lg font-medium hover:bg-gray-50 transition-colors border-gray-300 bg-transparent"
            >
              Close
            </Button>
          </div>

          <p className="text-xs text-gray-500 text-center">
            Free registration • Take only 2 minutes
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotRegisteredModal;
